import { useEffect, useState } from "react";
import { FaArrowLeft, FaArrowRight, FaCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import Back from "../../components/button/back";

function AllBerita() {
  const [berita, setBerita] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const beritaPerPage = 4;

  /* ================= FETCH ================= */
  useEffect(() => {
    const fetchBerita = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}api/berita`);
        const data = await res.json();
        setBerita(data);
      } catch (err) {
        console.error("Error fetching berita:", err);
      }
    };
    fetchBerita();
  }, []);

  /* ================= HELPER ================= */
  const getMainMedia = (item) => {
    if (item?.gambar?.length > 0) return item.gambar[0];
    return null;
  };

  /* ================= MEDIA ================= */
  const renderMedia = (item) => {
    const media = getMainMedia(item);

    if (!media) {
      return (
        <div className="w-full h-[220px] md:h-[380px] bg-gray-200 flex items-center justify-center">
          Tidak ada media
        </div>
      );
    }

    if (media.mimetype.startsWith("video/")) {
      return (
        <video
          src={`${process.env.REACT_APP_API_URL}api/berita/media/${media.filename}`}
          controls
          className="w-full h-[220px] md:h-[380px] object-cover"
        />
      );
    }

    if (media.mimetype.startsWith("image/")) {
      return (
        <img
          src={`${process.env.REACT_APP_API_URL}api/berita/media/${media.filename}`}
          alt={item.judul}
          className="w-full h-[220px] md:h-[380px] object-cover"
        />
      );
    }

    return null;
  };

  /* ================= SLIDER ================= */
  const handlePrevious = () =>
    setCurrentIndex((p) => (p === 0 ? berita.length - 1 : p - 1));
  const handleNext = () =>
    setCurrentIndex((p) => (p === berita.length - 1 ? 0 : p + 1));

  /* ================= PAGINATION ================= */
  const indexOfLast = currentPage * beritaPerPage;
  const indexOfFirst = indexOfLast - beritaPerPage;
  const currentBerita = berita.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(berita.length / beritaPerPage);

  return (
    <div className="bg-gray-50 py-10 px-4">
      {/* BACK */}
      <div className="max-w-7xl mx-auto mb-6">
        <Link to="/">
          <Back />
        </Link>
      </div>

      {/* ================= SLIDER ================= */}
      {berita.length > 0 && (
        <div className="max-w-7xl mx-auto relative rounded-2xl overflow-hidden shadow-lg mb-12">
          {renderMedia(berita[currentIndex])}

          <div className="absolute bottom-0 w-full bg-gradient-to-t from-black/70 to-transparent p-5">
            <h3 className="text-white text-xl font-bold">
              {berita[currentIndex].judul}
            </h3>
            <p className="text-white text-sm line-clamp-2">
              {berita[currentIndex].deskripsi}
            </p>
          </div>

          <button
            onClick={handlePrevious}
            className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full"
          >
            <FaArrowLeft />
          </button>

          <button
            onClick={handleNext}
            className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full"
          >
            <FaArrowRight />
          </button>
        </div>
      )}

      {/* ================= CARD LIST ================= */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {currentBerita.map((item) => {
          const media = getMainMedia(item);

          return (
            <Link
              key={item._id}
              to={`/berita/${item._id}`}
              className="bg-white rounded-xl shadow hover:shadow-xl transition overflow-hidden"
            >
              <div className="h-48">
                {media && media.mimetype.startsWith("image/") ? (
                  <img
                    src={`${process.env.REACT_APP_API_URL}api/berita/media/${media.filename}`}
                    className="w-full h-full object-cover"
                    alt={item.judul}
                  />
                ) : (
                  <div className="h-full bg-gray-200 flex items-center justify-center">
                    Tidak ada gambar
                  </div>
                )}
              </div>

              <div className="p-4">
                <p className="text-xs text-gray-500 mb-1">
                  {item.tanggal
                    ? new Date(item.tanggal).toLocaleDateString("id-ID")
                    : "-"}
                </p>
                <h4 className="font-bold text-lg mb-2 line-clamp-2">
                  {item.judul}
                </h4>
                <p className="text-sm text-gray-600 line-clamp-3">
                  {item.deskripsi}
                </p>
              </div>
            </Link>
          );
        })}
      </div>

      {/* ================= PAGINATION ================= */}
      <div className="flex justify-center items-center gap-4 mt-10">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
          className="p-2 bg-red-500 text-white rounded-full disabled:bg-gray-300"
        >
          <FaArrowLeft />
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentPage(i + 1)}
            className={`text-lg ${
              currentPage === i + 1 ? "text-red-500" : "text-gray-400"
            }`}
          >
            <FaCircle />
          </button>
        ))}

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
          className="p-2 bg-red-500 text-white rounded-full disabled:bg-gray-300"
        >
          <FaArrowRight />
        </button>
      </div>
    </div>
  );
}

export default AllBerita;
